<!-- eslint-disable max-len -->
<template>
  <div
    id="form-search-popover"
    class="component-card container-app-search">
    <j-title-header :options="title"/>

    <!-- <v-server-table
      v-show="load_first"
      ref="tableServer"
      :columns="columns"
      :options="options"
      class="jTable"
      @loading="loading"
      @loaded="loaded"
      @row-click="clickDetail">
      <div
        slot="beforeFilter"
        class="custom-search">
        <b-form inline>
          <b-button
            class="btn grey btn-import-form m__r--5"
            @click="createData">
            <i class="fa fa-plus fa-lg"/> Add
          </b-button>
          <b-button
            id="searchData"
            class="btn grey btn-import-form"
            @click="popoverSearchShow = true">
            <i class="fa fa-search fa-lg"/> Search
          </b-button>
        </b-form>
      </div>
    </v-server-table> -->
    <v-client-table
      v-show="load_first"
      :data="data_table"
      :columns="columns"
      :options="options"
      class="jTable"
      @row-click="clickDetail">
      <div
        slot="beforeFilter"
        class="custom-search">
        <b-form inline>
          <b-button
            v-if="!readOnly"
            class="btn grey btn-import-form m__r--5"
            @click="createData">
            <i class="fa fa-plus fa-lg"/> Add
          </b-button>
          <b-button
            id="searchData"
            class="btn grey btn-import-form"
            @click="popoverSearchShow = true">
            <i class="fa fa-search fa-lg"/> Search
          </b-button>
        </b-form>
      </div>

      <div
        slot="name"
        slot-scope="props">
        <div>
          <div
            v-if="props.row.photo"
            class="td">
            <b-img
              v-if="props.row.photo.includes('http')"
              :src="props.row.photo"
              rounded="circle"
              alt="img"
              class="m-1 round-bordered-img
              img-circle staff-img image-popup-link b-page-theme td"/>
            <b-img
              v-else
              :src="require('../../../assets/image/profile.png')"
              rounded="circle"
              alt="img"
              class="m-1 round-bordered-img
              img-circle staff-img image-popup-link b-page-theme td"/>
          </div>
          <div class="td p__t--15">
            {{ props.row.name }}
          </div>
        </div>
      </div>

      <div
        slot="pangkat_gol"
        slot-scope="props">
        {{ props.row.pangkat_gol !== 'N' && props.row.pangkat_gol !== '\\N' ? props.row.pangkat_gol : '' }}
      </div>
    </v-client-table>
    <jLoadingTable v-if="!load_first"/>

    <b-popover
      ref="searchModal"
      :show.sync="popoverSearchShow"
      container="form-search-popover"
      target="searchData"
      placement="right">
      <div class="m__b--10">Search Data</div>
      <b-form
        inline
        @keypress.13.prevent="filter(filter_data)">
        <j-select
          v-model="select_type"
          :disabled="false"
          :options="options_search"
          class="m__r--5"/>
        <j-input
          v-model="filter_data"
          placeholder="Search"
          class="m__r--5"/>
        <b-button
          class="btn blue outline"
          style="margin-top: -19px;"
          @click="filter(filter_data)">
          <i class="fa fa-search bold" /> Search
        </b-button>
      </b-form>
    </b-popover>

    <b-modal
      ref="modalCreatePegawai"
      class="mod-form"
      centered
      no-close-on-backdrop
      no-close-on-esc>
      <h2 style="margin-bottom: 30px; text-align: center">Create Data Pegawai</h2>
      <b-row>
        <b-col md="6">
          <b-form-group :class="{'error-input' : $v.data_master.kode_pegawai.$error}">
            <label> Kode Pegawai </label>
            <j-input
              v-model="$v.data_master.kode_pegawai.$model"
              placeholder="Kode Pegawai"/>
          </b-form-group>

          <b-form-group :class="{'error-input' : $v.data_master.password.$error}">
            <label> Password </label>
            <j-input
              v-model="$v.data_master.password.$model"
              :error-required="$v.data_master.password.$error"
              :type="password"
              placeholder="Password"/>
          </b-form-group>
          <b-form-checkbox v-model="show_pass">show password</b-form-checkbox><br><br>

          <b-form-group :class="{'error-input' : $v.data_master.confirm_password.$error || data_master.confirm_password !== data_master.password }">
            <label> Confirm Password </label>
            <j-input
              v-model="$v.data_master.confirm_password.$model"
              :error-required="$v.data_master.confirm_password.$error"
              :type="confirm_password"
              placeholder="Confirm Password"/>
          </b-form-group>
          <b-form-checkbox v-model="show_conpass">show password</b-form-checkbox><br><br>
        </b-col>
        <b-col md="6">
          <b-form-group :class="{'error-input' : $v.data_master.foto.$error}">
            <label> Photo </label><br>
            <j-singleupload
              v-model="$v.data_master.foto.$model"
              :accepted-file-type="['jpg', 'png', 'jpeg']"
              :api-token="token"
              :img-default="$v.data_master.foto.$model"
              :url-upload="url_upload"
              @url="getUrl"/>
            <label>
              Please choose file with supported format file jpg, png, jpeg.
            </label>
          </b-form-group>
        </b-col>
      </b-row>

      <hr>

      <b-form-group :class="{'error-input' : $v.data_master.nama_pegawai.$error}">
        <label> Nama Lengkap </label>
        <j-input
          v-model="$v.data_master.nama_pegawai.$model"
          placeholder="Nama Lengkap"/>
      </b-form-group>

      <b-form-group :class="{'error-input' : $v.data_master.nik.$error}">
        <label> NIK </label>
        <j-input
          v-model="$v.data_master.nik.$model"
          placeholder="NIK"/>
      </b-form-group>

      <b-form-group :class="{'error-input' : $v.data_master.jenis_kelamin.$error}">
        <label> Jenis Kelamin </label>
        <b-form-radio-group
          v-model="$v.data_master.jenis_kelamin.$model"
          :options="list_jenis_kelamin"
          :stacked="true"
          :disabled="false"
          class="jFormGroup"/>
      </b-form-group>

      <b-form-group :class="{'error-input' : $v.data_master.tempat_lahir.$error}">
        <label> Tempat Lahir </label>
        <j-input
          v-model="$v.data_master.tempat_lahir.$model"
          placeholder="Tempat Lahir"/>
      </b-form-group>

      <b-form-group :class="{'error-input' : $v.data_master.tanggal_lahir.$error}">
        <label> Tanggal Lahir </label>
        <j-datepicker
          v-model="$v.data_master.tanggal_lahir.$model"
          placeholder="Tanggal Lahir"
          format="MMM dd, yyyy"/>
      </b-form-group>

      <b-form-group :class="{'error-input' : $v.data_master.nama_ibukandung.$error}">
        <label> Nama Ibu Kandung </label>
        <j-input
          v-model="$v.data_master.nama_ibukandung.$model"
          placeholder="Nama Ibu Kandung"/>
      </b-form-group>

      <div class="float-to-right m__t--20">
        <b-button
          class="btn gray m__r--5"
          @click="closeModal">
          Cancel
        </b-button>
        <b-button
          class="btn blue"
          @click="saveData">
          Save
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
/* eslint-disable no-unused-vars, no-console, max-len */
import { mapActions } from 'vuex';
import { required } from 'vuelidate/lib/validators';
import { jPrivRoles } from '@/privilage/roles/jPrivRoles';

import jApiKurikulum from '@/services/jApiKurikulum';
import jLoadingTable from '@/components/skeleton-loading/jLoadingTable';

export default {
  components: {
    jLoadingTable,
  },
  mixins: [
    jPrivRoles,
  ],
  data() {
    return {
      title: {
        icon: 'fa-file',
        main_title: 'Kepegawaian',
        // opt_title: 'Requester',
      },
      popoverSearchShow: false,
      filter_data: '',
      select_type: 'name',
      options_search: [
        {
          text: 'ID',
          value: 'id',
        },
        {
          text: 'NIP',
          value: 'nip',
        },
        {
          text: 'Nama Pegawai',
          value: 'name',
        },
        {
          text: 'Kode Pegawai',
          value: 'kode_pegawai',
        },
        {
          text: 'Pangkat Golongan',
          value: 'pangkat_gol',
        },
        {
          text: 'Status',
          value: 'status_pegawai',
        },
      ],
      load_first: false,
      length_table: '',
      data_table: [],
      data_pegawai: [],
      selected_rows: [],
      columns: ['id', 'nip', 'kode_pegawai', 'name', 'pangkat_gol', 'status_pegawai'],
      options: {
        headings: {
          id: 'ID',
          nip: 'NIP',
          kode_pegawai: 'KODE PEGAWAI',
          name: 'NAMA PEGAWAI',
          pangkat_gol: 'PANGKAT GOLONGAN',
          status_pegawai: 'STATUS',
        },
        texts: {
          filterPlaceholder: 'Search',
          limit: 'Rows per page',
        },
        sortIcon: {
          base: 'fa',
          up: 'fa-chevron-up',
          down: 'fa-chevron-down',
          is: 'fa-sort',
        },
        debounce: 1000,
        filterable: true,
        sortable: [],
        perPage: 10,
        perPageValues: [10, 50, 100],
        // requestAdapter(data) {
        //   return {
        //     pagination: {
        //       limit: data.limit,
        //       page: data.page,
        //       column: data.orderBy ? data.orderBy : '',
        //       ascending: !!data.ascending,
        //       query: data.query ? data.query : '',
        //       query_type: data.query_type ? data.query_type : '',
        //     },
        //   };
        // },
        // requestFunction(data) {
        //   const getList = jApiKurikulum.listPegawai(data);
        //   return getList.catch((e) => {
        //     this.$store.dispatch('jStoreNotificationScreen/getProblemMessage', e.response.data.errors[0].message).bind(this);
        //   });
        // },
        // responseAdapter({ data }) {
        //   return {
        //     data: data.data ? data.data : [],
        //     count: data.length ? data.length : 0,
        //   };
        // },
      },

      // Create Data
      data_master: {
        kode_pegawai: '',
        password: '',
        confirm_password: '',
        foto: null,
        nama_pegawai: '',
        nik: '',
        jenis_kelamin: null,
        tempat_lahir: '',
        tanggal_lahir: null,
        nama_ibukandung: '',
      },
      show_pass: false,
      show_conpass: false,
      list_jenis_kelamin: [
        {
          value: 'L',
          text: 'Laki-Laki',
        },
        {
          value: 'P',
          text: 'Perempuan',
        },
      ],
      token: (JSON.parse(localStorage.getItem('Token'))).value,
    };
  },
  computed: {
    url_upload() {
      return `${process.env.GATE_URL}file/upload`;
    },

    password() {
      if (this.show_pass) {
        return 'text';
      }
      return 'password';
    },

    confirm_password() {
      if (this.show_conpass) {
        return 'text';
      }
      return 'password';
    },
  },
  watch: {
    // filter_data(val) {
    //   if (val === '') {
    //     this.$refs.tableServer.setFilter('');
    //   }
    // },
  },
  created() {
    this.getListPegawai().then((res) => {
      this.data_pegawai = res.data.data;
      this.data_table = this.data_pegawai;
      this.load_first = true;
    });
  },
  methods: {
    ...mapActions('jStoreNotificationScreen', ['toggleLoading', 'showLoading', 'hideLoading', 'toggleProblem']),
    ...mapActions('jStoreKurikulum', ['createPegawai', 'getListPegawai']),

    loading(val) {
      const a = val;
      a.pagination.query_type = this.select_type;

      if (this.load_first) {
        this.showLoading();
      }
    },

    loaded(data) {
      this.data_table = data.data.data;

      if (this.load_first) {
        this.hideLoading();
      } else {
        this.load_first = !this.load_first;
      }
    },

    refreshTable() {
      this.$refs.tableServer.getData();
    },

    filter(val) {
      // this.$refs.tableServer.setFilter(val);
      if (val) {
        this.data_table = this.data_pegawai.filter(f => String(f[this.select_type]).toLowerCase().includes(val.toLowerCase()));
      } else {
        this.data_table = this.data_pegawai;
      }
      this.popoverSearchShow = false;
    },

    clickDetail({ row }) {
      this.$router.replace(`/kepegawaian/detail/${row.id}`);
    },

    createData() {
      // this.$router.replace('/kepegawaian/create');
      this.$refs.modalCreatePegawai.show();
    },

    getUrl(data) {
      this.data_master.foto = data;
    },

    closeModal() {
      this.$refs.modalCreatePegawai.hide();
      this.data_master = {
        kode_pegawai: '',
        password: '',
        confirm_password: '',
        foto: null,
        nama_pegawai: '',
        nik: '',
        jenis_kelamin: null,
        tempat_lahir: '',
        tanggal_lahir: null,
        nama_ibukandung: '',
      };
      setTimeout(() => {
        this.$v.data_master.$reset();
      }, 1000);
    },

    saveData() {
      this.$v.data_master.$touch();
      if (!this.$v.data_master.$error) {
        this.createPegawai(this.data_master).then((res) => {
          if (!res.data.error) {
            setTimeout(() => {
              this.$store.dispatch('jStoreNotificationScreen/hideLoading');
              this.$refs.modalCreatePegawai.hide();
              this.$router.replace(`/kepegawaian/detail/${res.data.data[0].id}`);
            }, 1500);
          }
        });
      }
    },
  },
  validations() {
    return {
      data_master: {
        kode_pegawai: { required },
        password: { required },
        confirm_password: { required },
        foto: { required },
        nama_pegawai: { required },
        nik: { required },
        jenis_kelamin: { required },
        tempat_lahir: { required },
        tanggal_lahir: { required },
        nama_ibukandung: { required },
      },
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/views/kurikulum/kepegawaian/jKepegawaianList.vue